module.exports = __webpack_public_path__ + "3496b3edf82322a57c4e724de8bc5a82.png";